import { ONLY_LETTERS_NUMBERS_AND_SOME_SYMBOLS_CHECK } from '../../config/settings/regexes'

/**
 * To check if the given value contains only letters, numbers, and some symbols (._-,).
 */
export const checkOnlyLettersNumbersAndSomeSymbols = value => ONLY_LETTERS_NUMBERS_AND_SOME_SYMBOLS_CHECK.test(value)
